// Shared vocabulary for the trip-timetable drill-down, in a plain module because a `.svelte`
// file can't export types or helpers — both stop sheets, MapPage and TripTimetable read it.
//
// Subway, bus and ferry differ only in where the stop list comes from (indexed trip updates,
// a live SIRI onward-calls request, the ferry timetable with realtime overlaid), and all
// three return the same StopTimeUpdate shape, so the rendering is shared.

import { formatCountdown, formatShortClock } from '../../ui/transitTime'

export { parentStopId } from '@traintopia/domain'

export type TimetableSource =
  | { kind: 'subway'; tripId: string }
  | { kind: 'bus'; vehicleId: string }
  // A ferry trip's whole run, timetable with the live feed laid over it (/api/ferry/trips).
  | { kind: 'ferry'; tripId: string }
  // A LIRR / Metro-North trip's whole run, timetable with the live feed laid over it
  // (/api/rail/trips).
  | { kind: 'rail'; tripId: string }
  // An NJ Transit bus trip's whole run, timetable with the live feed laid over it
  // (/api/njbus/trips).
  | { kind: 'njbus'; tripId: string }

/**
 * What a rider carries through a "Transfer Here" tap: the vehicle they're on and when it
 * gets them there. The destination sheet uses it to hide connections leaving before the
 * rider could be standing there — a departure 3 minutes out is noise to someone whose train
 * doesn't pull in for another 40.
 */
export interface TransferContext {
  /** Unix seconds — the arriving vehicle's predicted time at the transfer stop. */
  arriveAt: number
  /** Route the rider arrives on, for the banner. */
  routeId: string
  /** Human name of the transfer stop, as the timetable labelled it. */
  stopName: string
}

export function fmtClock(ts: number | null): string {
  return formatShortClock(ts)
}

export function fmtMin(ts: number | null): string {
  return formatCountdown(ts)
}
